import { useRef, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { $messageCentreStore } from '@lib/store';
import { ValidateUtils } from '@shared/utils';
import { BaseInput, Button, ColorsEnum, ErrorMessage, Icon, MessageFile, Text, Textarea } from '@shared/widgets';
import PaperclipIcon from '@assets/icons/paperclip.svg';

interface FormSchema {
  subject: string;
  message: string;
}

export const NewMessage = () => {
  const [file, setFile] = useState<File>();

  const formControl = useForm<FormSchema>();

  const onSubmit: SubmitHandler<FormSchema> = ({ subject, message: body }) => {
    const formData = new FormData();
    file && formData.append('file', file);
    $messageCentreStore.events.createNewThreadWithMessage({
      subject,
      body,
      file: file ? formData : undefined,
    });
    formControl.reset({ subject: '', message: '' });
    setFile(undefined);
  };

  const uploadRef = useRef<HTMLInputElement>(null);

  const upload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
  };

  return (
    <div className='p-8 w-80 bg-white dark:bg-soft-black'>
      <Text weight='medium' size='lg' className='mb-4 text-center'>
        New Message
      </Text>
      <form className='flex flex-col gap-6' onSubmit={formControl.handleSubmit(onSubmit)}>
        <div className='flex flex-col gap-1'>
          <Controller
            name='subject'
            control={formControl.control}
            rules={{ required: ValidateUtils.requiredErrorMessage }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <BaseInput type='text' placeholder='Enter the subject' value={value} onChange={onChange} />
                <ErrorMessage text={error?.message} />
              </>
            )}
          />
        </div>
        <div className='flex flex-col gap-1'>
          <Controller
            name='message'
            control={formControl.control}
            rules={{ required: ValidateUtils.requiredErrorMessage }}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <>
                <Textarea className='m-0' fitContent placeholder='Enter your message here' value={value} onChange={onChange} />
                <ErrorMessage text={error?.message} />
              </>
            )}
          />
        </div>
        {file ? (
          <MessageFile downloadShow attachment={{ id: '', filename: file.name, fileSizeBytes: file.size }} onRemove={() => setFile(undefined)} />
        ) : (
          <>
            <input ref={uploadRef} id='contained-button-file' className='hidden' type='file' accept='image/*' onChange={upload} />
            <label htmlFor={'contained-button-file'}>
              <Button color='dashed' fullWidth onClick={() => uploadRef.current?.click()}>
                <Icon icon={<PaperclipIcon />} color='inherit' />
                Add attachment
              </Button>
            </label>
          </>
        )}
        <Button color='primary' type='submit' fullWidth>
          Send
        </Button>
        <Text className='text-center' weight='light' size='sm' color={ColorsEnum.Gray}>
          Support team will contact you by phone call as soon as the problem will be solved.
        </Text>
      </form>
    </div>
  );
};
